/** Türkçe büyük/küçük harf — CSS text-transform: uppercase İ→I hatası verir */
export function toTurkishUpperCase(value) {
  return String(value).toLocaleUpperCase('tr-TR');
}

export function toTurkishLowerCase(value) {
  return String(value).toLocaleLowerCase('tr-TR');
}
